// extracted by mini-css-extract-plugin
export default {"buttonDelete":"CloseButton_buttonDelete__v85UN","trash":"CloseButton_trash__tw7QO"};